import React from 'react';
import { ClientId } from '../Field';
import { IconButton } from '../../../../components/IconButton';

interface PropTypes {
  sectionId: ClientId;
  removeDisabled: boolean;
  onUp: (sectionId: ClientId) => void;
  onDown: (sectionId: ClientId) => void;
  onRemove: (sectionId: ClientId) => void;
}

export function SectionHeader(props: PropTypes) {
  return (
    <div className='d-flex align-items-center'>
      <div className='fs-4 me-auto fw-bold'>
        Section <span className='text-danger'>*</span>
      </div>
      <div className='d-flex gap-2'>
        <IconButton
          color='secondary'
          size='sm'
          iconName='bi-trash'
          disabled={props.removeDisabled}
          onClick={() => props.onRemove(props.sectionId)}
        />
        <IconButton
          color='secondary'
          size='sm'
          iconName='bi-arrow-up'
          onClick={() => props.onUp(props.sectionId)}
        />
        <IconButton
          color='secondary'
          size='sm'
          iconName='bi-arrow-down'
          onClick={() => props.onDown(props.sectionId)}
        />
      </div>
    </div>
  );
}
